"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signMultipleTransactions = void 0;
const jsontokens_1 = require("jsontokens");
const provider_1 = require("../provider");
const signMultipleTransactions = async (options) => {
    const provider = await (0, provider_1.getProviderOrThrow)(options.getProvider);
    const { psbts } = options.payload;
    if (!psbts || !psbts.length) {
        throw new Error('psbts array is required');
    }
    if (psbts.length > 100) {
        throw new Error('psbts array must contain less than 100 psbts');
    }
    try {
        const request = (0, jsontokens_1.createUnsecuredToken)(options.payload);
        const response = await provider.signMultipleTransactions(request);
        options.onFinish?.(response);
    }
    catch (error) {
        console.error('[Connect] Error during sign Multiple transactions request', error);
        options.onCancel?.();
    }
};
exports.signMultipleTransactions = signMultipleTransactions;
